<script>
export default {
  name: 'Catalog'
};
</script>

<template>
  <div class="catalog-content">
    <router-view />
  </div>
</template>

<style lang="scss" scoped>
.catalog-content {
  margin: 2vw;
  padding: 1vw;
  background-color: #F4F8F9;
}

@import '~vuetify/src/styles/settings/_variables';
@media #{map-get($display-breakpoints, 'xs-only')}{
  .catalog-content {
    margin: 0;
    padding: 3vw;
  }
}

</style>
